/*eslint-disable */
import React, { Component } from "react";
import { Grid, Segment, Placeholder, Label, Pagination } from "semantic-ui-react";
import { Link } from "react-router-dom";
import GridPlaceholder from "./gridPlaceholder";
import RouteManager from "./routeManager";
import ReadAxios from "../../axiosComponent/read";
import ReadAxiosRequestAxios from '../../axiosComponent/allAxiosCommonRequest'
import OrdersHeader from '../../orderComponent/ordersHeaders';
import MiniPlaceholder from "./miniPlaceHolder";
import VehicleType from "./vehicleType";
import { translate } from "react-i18next";
import BLrender from "../../common/bl_no";
import moment from 'moment';
import 'moment-timezone';
import LoadingPlaceholder from "../../placeholderComponent/loadingPlaceholder";
import cogoToast from "cogo-toast";
import { DEMAP_INVOICE_ERROR } from '../../../utils/toastMsgConstant'
import { NO_RECORDS_FOUND } from '../../../utils/validationConstant'
import { DD_MM_YYYY_HH_mm, orderNoTitleCustomer, branch_Ids, vendor_Id, time_zone } from '../../../utils/constant'

export class shipmentGridView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listItems: [],
      isFetching: false,
      page: 0,
      totalPages: 0,
      currentPage: this.props.pageNoOn,
      itemCount: 10,
      itemsPerPage: 10,
      setPageValue: 10,
      statusFilter: "",
      searchFilterGrouping: "",
      exportDataFromSearch: null,
      status: []
    };
  }

  async componentDidMount() {

    // console.log("PPPPPPPPPPPOOOO  componentDidMountSTARTS  OOOOIIIIIIIIIIIIIII")
    // console.log(this.props)
    // console.log("PPPPPPPPPPPOOOO  componentDidMountENDS  OOOOIIIIIIIIIIIIIII")

    if (this.props?.pageNoOn) {
      this.setState({ currentPage: this.props.pageNoOn }, () => {
        this.getInitalData(this.props.pageNoOn)
      })
    }
    else
      this.getInitalData(1)
  }

  componentDidUpdate(prevProps) {
    // console.log("PPPPPPPPPPPOOOO  componentDidUpdateSTARTS  OOOOIIIIIIIIIIIIIII")
    // console.log(this.props)
    // console.log(prevProps)
    // console.log("PPPPPPPPPPPOOOO  componentDidUpdateENDS  OOOOIIIIIIIIIIIIIII")

    if (this.props?.pageNoOn != prevProps.pageNoOn) {
      this.setState({ currentPage: this.props.pageNoOn }, () => {
        this.getInitalData(this.props.pageNoOn)
      })
    }
  }

  getInitalData = (activePage) => {
    let booking_branch_ids = branch_Ids?.length > 0 ? branch_Ids.toString()
      : ''
    this.setState({
      isFetching: true,
    })
    let vendorId = vendor_Id
    ReadAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/vendor/${vendorId}?${this.state.searchFilterGrouping}&booking_branch_ids=${booking_branch_ids}&page=${activePage}&limit=${this.state.itemsPerPage}${this.state.statusFilter}` })
      .then((res) => {
        this.setState(
          {
            isFetching: false,
            listItems: res?.data?.result || [],
            totalPages: res?.data?.meta?.totalPages || 0,
          },
        );
      })
      .catch((err) => {
        console.log('err', err);
      });
  }

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ currentPage: activePage })
    this.props.updatePaginationPage(activePage)
    this.getInitalData(activePage);
  }

  handleStatusChange = (data) => {
    this.setState({ status: data.status })
    if (data.length !== 0) {
      let statusOrder = `&status=${data?.status ? data.status.join(',') : data ? data.join(',') : ''}`
      this.setState({ statusFilter: statusOrder }, () => {
        this.props.updatePaginationPage(1)
        this.getInitalData(1);
      })
    } else {
      let statusOrder = `&status=`
      this.setState({ statusFilter: statusOrder }, () => {
        this.props.updatePaginationPage(1)
        this.getInitalData(1);
      })
    }
  }

  // scroll listener function
  handleScroll = () => {
    let divInnerHeight = document.getElementsByClassName("style");
    let scrollLimit = 59;
    scrollLimit = scrollLimit + 675 * (this.state.page - 1);
    //console.log(scrollLimit, divInnerHeight[0].scrollTop);
    if (
      Math.ceil(
        divInnerHeight[0].scrollTop > scrollLimit || this.state.isFetching
      )
    ) {
      this.setState({ isFetching: true }, () => {
        this.incrementPage();
      });
    }
  };

  // new page increment
  incrementPage = () => {
    if (!this.state.isFetching) return;
    this.fetchMoreListItems();
  };

  fetchMoreListItems = () => {
    this.fetchData();
    this.setState({ isFetching: false }, () => this.incrementPage());
  };
  exporttrueDataGrid = () => {
    let payload = {
      bl_no: this.state?.exportDataFromSearch?.bl_no ? this.state.exportDataFromSearch.bl_no : "",
      vendor_id: this.state?.exportDataFromSearch?.vendor_id ? this.state.exportDataFromSearch.vendor_id : "",
      vehicle_no: this.state?.exportDataFromSearch?.vehicle_no ? this.state.exportDataFromSearch.vehicle_no : "",
      order_reference_no: this.state?.exportDataFromSearch?.order_reference_no ? this.state.exportDataFromSearch.order_reference_no : "",
      common_order_number: this.state?.exportDataFromSearch?.common_order_number ? this.state.exportDataFromSearch.common_order_number : "",
      delivery_reference_no: this.state?.exportDataFromSearch?.delivery_reference_no ? this.state.exportDataFromSearch.delivery_reference_no : "",
      required_on: this.state?.exportDataFromSearch?.required_on ? this.state.exportDataFromSearch.required_on : "",
      end_required_on: this.state?.exportDataFromSearch?.end_required_on ? this.state.exportDataFromSearch.end_required_on : "",
      invoice_no: this.state?.exportDataFromSearch?.invoice_no ? this.state.exportDataFromSearch.invoice_no : "",
      status: this.state.status,
      transporter_lr_no: this.state?.exportDataFromSearch?.transporter_lr_no ? this.state.exportDataFromSearch.transporter_lr_no : "",
      route_id: this.state?.exportDataFromSearch?.route_id ? this.state.exportDataFromSearch.route_id : "",
      consignor_id: this.state?.exportDataFromSearch?.consignor_id ? this.state.exportDataFromSearch.consignor_id : "",
      consignee_id: this.state?.exportDataFromSearch?.consignee_id ? this.state.exportDataFromSearch.consignee_id : "",
      from_order_created_on: this.state?.exportDataFromSearch?.from_order_created_on ? this.state.exportDataFromSearch.from_order_created_on : "",
      to_order_created_on : this.state?.exportDataFromSearch?.to_order_created_on ? this.state.exportDataFromSearch.to_order_created_on : "",
      lr_no : this.state?.exportDataFromSearch?.lr_no ? this.state.exportDataFromSearch.lr_no : "",
    }

    let bookingBranchIds = branch_Ids.length > 0 ? JSON.stringify(branch_Ids.toString()) : "";
    let vendorId = vendor_Id

    ReadAxiosRequestAxios({
      url: `${process.env.REACT_APP_TA_API_URL}/orders/vendor/${vendorId}/excel/export?bl_no=${payload.bl_no}&vendor_name=${payload.vendor_id}&transporter_lr_no=${payload.transporter_lr_no}&vehicle_no=${payload.vehicle_no}&delivery_reference_no=${payload.delivery_reference_no}&start_required_on=${payload.required_on}&end_required_on=${payload.end_required_on}&order_reference_no=${payload.order_reference_no}&invoice_no=${payload.invoice_no}&common_order_number=${payload.common_order_number}&booking_branch_ids=${bookingBranchIds}&status=${payload.status}&route_id=${payload.route_id}&consignor_id=${payload.consignor_id}&consignee_id=${payload.consignee_id}&from_order_created_on=${payload.from_order_created_on}&to_order_created_on=${payload.to_order_created_on}&lr_no=${payload.lr_no}&page=1&limit=10&`,
      method: "get",
      noQ: true
    })
      .then((res) => {
        cogoToast.success(res.data.message);
        if (res?.status == 200) {
          this.setState({ responseReceived: true })
        }
        this.setState({ spinnerLoading: false })
      })
      .catch((err) => {
        if (err?.response?.data?.message)
          cogoToast.error(err.response.data.message);
        else
          cogoToast.error(DEMAP_INVOICE_ERROR);
        this.setState({ spinnerLoading: false })
      });
  }

  handleMetaSearch = (payload) => {
    this.state.exportDataFromSearch = payload;
    let url = `bl_no=${payload.bl_no}&transporter_lr_no=${payload.transporter_lr_no}&vendor_name=${payload.vendor_id}&vehicle_no=${payload.vehicle_no}&delivery_reference_no=${payload.delivery_reference_no}&start_required_on=${payload.required_on}&end_required_on=${payload.end_required_on}&order_reference_no=${payload.order_reference_no}&invoice_no=${payload.invoice_no}&common_order_number=${payload.common_order_number}&route_id=${payload.route_id}&consignor_id=${payload.consignor_id}&consignee_id=${payload.consignee_id}&from_order_created_on=${payload.from_order_created_on}&to_order_created_on=${payload.to_order_created_on}&lr_no=${payload.lr_no}`

    this.setState({ searchFilterGrouping: url }, () => {
      console.log(url)
      this.props.updatePaginationPage(1)
      this.getInitalData(1)
    });


  };


  render() {
    const { t } = this.props;
    let timezone = time_zone
    let content = ""

    return (
      <React.Fragment>
        <OrdersHeader
          hideTransporter={true}
          hideVehicleNumber={true}
          showStatusFilter={true}
          handleMetaSearch={this.handleMetaSearch}
          allotedOrdersStatusShow={this.props.allotedOrdersStatusShow}
          handleStatusChange={this.handleStatusChange}
          title={t("orders.alloted_title") || "Alloted Orders"}
          LinkName="/add-shipment"
          handleSearch={this.handleChange}
          hideFilter={false}
          // importDataGrid={this.importDataGrid}
          exporttrueDataGrid={this.exporttrueDataGrid}
          exportHidden={this.props.exportHidden}
          radioToggle={this.props.radioToggle}
          toggleView={this.props.toggleView}
          toggle={this.props.toggle}
          baseURL={this.props.baseURL}
          dataPresent={this.state.listItems.length > 0 ? true : false}
          allotedOrder={true}
          searchLoading={this.state.isFetching}
        />
        <div
          className="animated slideInDown m-2 style"
          style={{ width: "99%", height: "100%", paddingBottom: "50px" }}
        // onScroll={this.handleScroll}
        >
          {this.state.listItems.length > 0 ? (
            this.state.listItems.map((item, index) => {
              content = <BLrender id={item.vendor_order_id} />
              return (
                <Segment raised className="ml-3 p-0" key={index} size="mini">
                  <Link
                    target="_blank"
                    to={{
                      pathname: "/alloted-order-details",
                      state: { item, index },
                      search: `?shipmentId=${item.vendor_order_id}`,
                    }}
                  >
                    <Grid columns={1} className="m-1">
                      <Grid.Row textAlign="center" className="m-0">
                        <Grid.Column width={4} className="ml-3" >
                          <Grid columns="3">
                            <Grid.Row className="pb-0 pt-0">
                              <Grid.Column>
                                <Label as="a" color='orange' ribbon className="ml-n1">
                                  {orderNoTitleCustomer ? "Booking No" : t("list_view.order_no") || "Order No"} : {item.order_reference_no}
                                </Label>
                                <label className="w3-text-gray mt-3 labelName text-nowrap">
                                  {item.shipment.movement_type == "Import" || item.shipment.movement_type == "Importar" ? t("list_view.estimated_on") : t("list_view.required_on")}
                                </label>
                                <label className="p-bold-600 text-nowrap">
                                  {moment.parseZone(item.shipment.required_on).format(DD_MM_YYYY_HH_mm)}
                                </label>
                              </Grid.Column>
                            </Grid.Row>
                          </Grid>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <RouteManager budgeted_kms={item.budgeted_kms} routeId={item.route_id} movement_type={item.shipment.movement_type} />
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Label color={item.allotment_status.allotment_text == "Broadcasted" ? "blue" : (item.allotment_status.allotment_text == "Rebid Request" ? "yellow" : (item.allotment_status.allotment_text == "Reject" ? "red" : "grey"))} className="mt-3">
                            {item.allotment_status.allotment_text}
                          </Label>
                        </Grid.Column>
                        <Grid.Column width={3} textAlign="right" className="mt-2">
                          <div>
                            <span
                              className="sumo_truck_quantity"
                              style={{
                                width: "55px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                            </span>
                            <img src="assets/svg/sumo_truck.svg" alt="sumo_truck" width="60%" />
                          </div>
                          <label className="w3-text-blue bfonter">
                            {t("list_view.movement_type") || "Movement Type"} : &nbsp;
                            <span className="p-bold-600 movement_type">{item.shipment.movement_type}</span>
                          </label>
                        </Grid.Column>
                      </Grid.Row>
                      {item.shipment.movement_type == "Import" || item.shipment.movement_type == "Importar" ?
                        <Grid.Row className="mr-0 ml-0 p-2 footer-text">
                          <span className="ml-3"> {t("list_view.bl_no") || "BL No."} :  </span>  <span className="ml-2"> <span>{item.bl_numbers != "" ? item.bl_numbers : "NA"}</span> </span>
                        </Grid.Row>
                        : ""}
                    </Grid>
                  </Link>
                </Segment>
              );
            })
          ) :
            <>
              {this.state.listItems.length == 0 && this.state.isFetching == false ? (
                <div>{NO_RECORDS_FOUND}</div>
              ) : (
                <LoadingPlaceholder />
              )}
            </>
          }
        </div>

        <div className="life-cycle w3-white p-2 mt-9">
          {/* {console.log("The All-American Rejects - It Ends Tonight")}
          {console.log(this.state.currentPage)} */}
          <Pagination
            defaultActivePage={this.props.pageNoLast || this.state.currentPage}
            firstItem={null}
            lastItem={null}
            onPageChange={this.handlePaginationChange}
            pointing
            secondary
            totalPages={this.state.totalPages}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default translate("shipment")(shipmentGridView);
